import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Dropdown, Menu, Pill } from '@storable/canaveral-components';
import cx from 'classnames';
import { BUILDER } from 'shared/abilities';
import Authorization from 'web/containers/Authorization';
import { LANGUAGE_NAME_MAPPING, LOCALE_PILL_VALUES } from 'shared/i18n';
import Icon from '../../../../modules/react/components/stateless/Icon';
import styles from './BuilderLanguagesMenu.scss';
import ConfirmationModal from './ConfirmationModal';

const propTypes = {
  createPageForLocale: PropTypes.func.isRequired,
  currentLocale: PropTypes.string.isRequired,
  enableableLocales: PropTypes.arrayOf(PropTypes.string).isRequired,
  enabledLocalePages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    pageId: PropTypes.string,
    locale: PropTypes.string.isRequired,
  })).isRequired,
  hide: PropTypes.bool.isRequired,
};

const defaultProps = {};

class BuilderLanguagesMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      locale: null,
    };
  }

  onClick = locale => () => this.setState({
    locale,
    show: true,
  });

  onConfirm = () => {
    const { locale } = this.state;
    const { createPageForLocale } = this.props;

    createPageForLocale(locale);
    this.onDismiss();
  }

  onDismiss = () => this.setState({
    show: false,
  })

  getPillDiameter = locale => (
    LOCALE_PILL_VALUES[locale].length <= 2 ? 30 : null
  )

  render = () => {
    const {
      currentLocale,
      enableableLocales,
      enabledLocalePages,
      hide,
    } = this.props;

    const {
      show,
      locale: newLocale,
    } = this.state;

    if (hide) {
      return false;
    }

    const toggle = (
      <Dropdown.Toggle>
        <Pill
          diameter={this.getPillDiameter(currentLocale)}
          className={styles.enabled}
        >
          {LOCALE_PILL_VALUES[currentLocale]}
        </Pill>
      </Dropdown.Toggle>
    );

    return (
      <React.Fragment>
        <Authorization action="manage" subject={BUILDER}>
          {authorized => (
            <Dropdown
              toggle={toggle}
              className={styles.dropdown}
            >
              <Menu>
                {enabledLocalePages.length > 0 && <Menu.Header title="Switch Languages" />}
                {enabledLocalePages.map(({ id, pageId, locale }) => (
                  <Menu.Item
                    key={id || pageId}
                    componentClass={Link}
                    to={`/admin/page/edit/${id || pageId}`}
                  >
                    <Pill
                      diameter={this.getPillDiameter(locale)}
                      className={cx(styles.pill, styles.enabled)}
                    >
                      {LOCALE_PILL_VALUES[locale]}
                    </Pill>
                    {LANGUAGE_NAME_MAPPING[locale]}
                  </Menu.Item>
                ))}
                {authorized && enableableLocales.length > 0 && <Menu.Header title="Add Language Page" />}
                {authorized && enableableLocales.map((locale) => {
                  const diameter = this.getPillDiameter(locale);

                  return (
                    <Menu.Item
                      key={locale}
                      onClick={this.onClick(locale)}
                    >
                      <Pill
                        context="positive"
                        diameter={diameter}
                        className={cx(styles.pill, styles.enable)}
                      >
                        <span className={styles.enableText}>
                          {LOCALE_PILL_VALUES[locale]}
                        </span>
                        <div className={styles.enableIcon}>
                          <Icon id="add-group" label={LOCALE_PILL_VALUES[locale]} />
                        </div>
                      </Pill>
                      <Pill
                        diameter={diameter}
                        className={cx(styles.pill, styles.enableable)}
                      >
                        {LOCALE_PILL_VALUES[locale]}
                      </Pill>
                      {LANGUAGE_NAME_MAPPING[locale]}
                    </Menu.Item>
                  );
                })}
              </Menu>
            </Dropdown>
          )}
        </Authorization>
        <ConfirmationModal
          show={show}
          buttonText="Yes"
          title="Enable Language"
          onDismiss={this.onDismiss}
          onConfirm={this.onConfirm}
          confirmButtonContext="positive"
        >
          <span className={styles.confirmMessage}>
            {`You're about to enable the ${LANGUAGE_NAME_MAPPING[newLocale]} version of this page.
            Are you sure you want to proceed?`}
          </span>
        </ConfirmationModal>
      </React.Fragment>
    );
  };
}

BuilderLanguagesMenu.propTypes = propTypes;
BuilderLanguagesMenu.defaultProps = defaultProps;

export default BuilderLanguagesMenu;
